import * as React from 'react'
import Backdrop from '@mui/material/Backdrop'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import Fade from '@mui/material/Fade'
import CloseIcon from '@mui/icons-material/Close'
import Button from '@mui/material/Button'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import { useLang } from '../../i18n/Metronici18n'
import { AllMessages, TranslateDOM, useLocalStorage } from '../../../app/utils'
import { Lang } from '../../../app/modules/auth/apis'

type Props = {
  children: any
  open: boolean
  handleCloseModal: (close: boolean) => void
  widthModal?: string
  maxWidthModal?: string
  modalTitle: string
  ModalBtn: React.FC
  hideOverFlow?: boolean
}

const CustomModal: React.FC<Props> = ({
  children,
  open,
  handleCloseModal,
  widthModal,
  modalTitle,
  ModalBtn,
  maxWidthModal,
  hideOverFlow,
}) => {
  const locale = useLang()
  const [lang] = useLocalStorage<Lang>('i18nConfig', {selectedLang: 'vi'})
  const style = {
    position: 'relative',
    minWidth: widthModal ? widthModal : '60%',
    maxWidth: maxWidthModal ? maxWidthModal : '80%',
    bgcolor: 'background.paper',
    borderRadius: '5px',
    boxShadow: 24,
    padding: '10px 12px',
  }

  const styleContainer = {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'center',
  }

  const handleClose = () => handleCloseModal(false)

  React.useEffect(() => {
    if(locale !== 'vi') {
      TranslateDOM()
    }
  }, [])

  return (
    <>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        open={open}
        onClose={(_, reason) => {
          if (reason !== 'backdropClick') {
            handleClose()
          }
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 300,
        }}
      >
        <Fade in={open}>
          <div className='test' style={styleContainer}>
            <Box sx={style}>
              <div className='modal-header'>
                <h5>{modalTitle}</h5>
                <div className='modal-header-close-btn' onClick={() => handleClose()}>
                  <CloseIcon />
                </div>
              </div>
              <div
                className='modal-content'
                style={{
                  overflowX: hideOverFlow ? 'inherit' : 'hidden',
                  overflowY: hideOverFlow ? 'inherit' : 'auto',
                }}
              >
                {children}
              </div>
              <div className='modal-footer'>
                <ModalBtn />
                <Button
                  size='small'
                  variant='outlined'
                  className='modal-footer-btn custom-form-feature-btn'
                  aria-hidden="false"
                  onClick={() => handleClose()}
                >
                  <CloseOutlinedIcon />
                  {AllMessages[lang.selectedLang].BTN_DONG}
                </Button>
              </div>
            </Box>
          </div>
        </Fade>
      </Modal>
    </>
  )
}

export {CustomModal}
